export default "__VITE_ASSET__cYwoMCT2__"